import React from 'react'

export default function Todo({todo, toggleTodo}){
  function handleTodoClick(){
    toggleTodo(todo.id)
  }
  return (
    // Prints out the todo
    // Whether the checkbox is checked or not is determined by todo.complete
    <div>
      <label>
         <input type="checkbox" checked={todo.complete} onChange={handleTodoClick} />
         {todo.name}
       </label>
    </div>
  )
}
